/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum ObjectCategory {
  ASSET = "ASSET",
  DEVICE = "DEVICE",
  PEOPLE = "PEOPLE",
  PASSIVE = "PASSIVE"
}
